import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { CommonModule } from '@angular/common';
import { LogoutButtonComponent } from '../logout-button/logout-button.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, LogoutButtonComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  redirectToAdmin(): void {
    this.router.navigateByUrl('admin');
  }

  isAdmin(): boolean {
    return this.authenticationService.isAdmin();
  }
}
